import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const ImageAnimate = ({ src, alt }) => {

    const containerRef = useRef(null);
    const imageRef = useRef(null);

    useEffect(() => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: containerRef.current,
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
        });

        tl.from(containerRef.current, {
            xPercent: -100,
            opacity: 0,
            duration: 1.2,
            ease: 'power2.out',
        });

        tl.from(imageRef.current, {
            xPercent: 100,
            scale: 1.3,
            duration: 1.2,
            ease: 'power2.out',
        }, '-=1'); // start at the same time

        return () => {
            ScrollTrigger.getAll().forEach(t => t.kill());
        };
    }, []);

    return (
        <div ref={containerRef} className="reveal-container">
            <img ref={imageRef} src={src} alt={alt} className="reveal-img" />
        </div>
    );
};

export default ImageAnimate;